export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/non_fiction.a6851c6.svg";